import axios from "axios";
import qs from "qs";
import config from "../config";
var AbstractClient = (function () {
    function AbstractClient(axiosClient) {
        if (axiosClient === void 0) { axiosClient = null; }
        this.axios = axiosClient !== null && axiosClient !== void 0 ? axiosClient : axios.create({
            baseURL: this.getBaseUrl(),
            timeout: this.getTimeout(),
            withCredentials: this.withCredentials(),
        });
        this.axios.interceptors.response.use(function (response) { return response; }, function (error) {
            var _a;
            if ([401, 403].includes((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status)) {
                var currentUri = window.location.href.replace(window.location.origin, "");
                window.location.href = "".concat(config.ALLIT_URL, "/cart/logoff.php?next=").concat(encodeURIComponent(currentUri));
            }
            return Promise.reject(error);
        });
    }
    AbstractClient.prototype.getTimeout = function () {
        return 30 * 1000;
    };
    AbstractClient.prototype.withCredentials = function () {
        return true;
    };
    AbstractClient.prototype.getUrlEncodedParamSerializer = function () {
        return (function (params) { return qs.stringify(params); });
    };
    return AbstractClient;
}());
export default AbstractClient;
//# sourceMappingURL=AbstractClient.js.map